var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.7437H5C3.897 10.7437 3 11.6407 3 12.7437V20.7437C3 21.8467 3.897 22.7437 5 22.7437H19C20.103 22.7437 21 21.8467 21 20.7437V12.7437C21 11.6407 20.103 10.7437 19 10.7437ZM5 20.7437V12.7437H19L19.002 20.7437H5ZM5 6.74365H19V8.74365H5V6.74365ZM7 2.74365H17V4.74365H7V2.74365Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.8a90ca0ad1f4d9c71191ec18e5fc272a.svg";
export { ForwardRef as ReactComponent };